import React from 'react';
import { Navigate } from 'react-router-dom';
import useUser from '../../hooks/useUser';

type Props = {
  children: React.ReactNode;
  fallbackTo?: string;
};

const RequireGlobalAccess = ({ children, fallbackTo = '/dashboard' }: Props) => {
  const { loading, user, canAccessAllSites } = useUser();

  if (loading) return <div className="p-4">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessAllSites && user.role !== 'SuperAdmin') return <Navigate to={fallbackTo} replace />;

  return <>{children}</>;
};

export default RequireGlobalAccess;

